// Sh_pl = saaya_health_patient_login
export const pateintLogin = {
  sh_pl_logo: "sh_pl_logo",
  sh_pl_text1: "sh_pl_text1",
  sh_pl_text2: "sh_pl_text2",
  sh_pl_email: "sh_pl_email",
  sh_pl_pass: "sh_pl_pass",
  sh_pl_remember: "sh_pl_remember",
  sh_pl_forgot_pass: "sh_pl_forgot_pass",
  sh_pl_sign_in_btn: "sh_pl_sign_in_btn",
  sh_pl_reg_btn: "sh_pl_reg_btn",
  sh_pl_cnslr_btn: "sh_pl_cnslr_btn",
  sh_cl_cnslr_sign_in:"sh_cl_cnslr_sign_in"
};

// Counsellor Login Constant
export const counsellorLogin = {
  sh_cl_logo: "sh_cl_logo",
  sh_cl_text1: "sh_cl_text1",
  sh_cl_text2: "sh_cl_text2",
  sh_cl_email: "sh_cl_email",
  sh_cl_pass: "sh_cl_pass",
  sh_cl_remember: "sh_cl_remember",
  sh_cl_forgot_pass: "sh_cl_forgot_pass",
  sh_cl_sign_in_btn: "sh_cl_sign_in_btn",
};

// Patient Register Constant
export const patientRegister = {
  sh_pr_logo: "sh_pr_logo",
  sh_pr_text1: "sh_pr_text1",
  sh_pr_text2: "sh_pr_text2",
  sh_pr_name: "sh_pr_name",
  sh_pr_email: "sh_pr_email",
  sh_pr_employee_id: "sh_pr_employee_id",
  sh_pr_subsidery: "sh_pr_subsidery",
  sh_pr_age: "sh_pr_age",
  sh_pr_pass: "sh_pr_pass",
  sh_pr_c_pass: "sh_pr_c_pass",
  sh_pr_term_cond: "sh_pr_term_cond",
  sh_pr_sign_in_btn: "sh_pr_sign_in_btn",
  sh_pr_login_redirect_btn: 'sh_pr_login_redirect_btn' 
};

// Forgot password Constant
export const forgorPassword = {
  sh_fp_logo: "sh_fp_logo",
  sh_fp_text1: "sh_fp_text1",
  sh_fp_text2: "sh_fp_text2",
  sh_fp_email: "sh_fp_email",
  sh_fp_btn: "sh_fp_btn",
  sh_fp_cs_btn: "sh_fp_cs_btn",
};

// Account Verify Component Constant
export const accountVerify = {
  sh_av_logo: "sh_av_logo",
  sh_av_text1: "sh_av_text1",
  sh_av_text2: "sh_av_text2",
  sh_av_btn: "sh_av_btn",
  sh_av_cs_btn: "sh_av_cs_btn",
};

// Email confirmation Constant, after creating account 
export const emailConfirm = {
  sh_ec_logo: "sh_ec_logo",
  sh_ec_text1: "sh_ec_text1",
  sh_ec_text2: "sh_ec_text2",
  sh_ec_btn: "sh_ec_btn",
  sh_ec_cs_btn: "sh_ec_cs_btn",
};

// Email Sent after inserting email for reset password
export const emailSent = {
  sh_es_logo: "sh_es_logo",
  sh_es_text1: "sh_es_text1",
  sh_es_text2: "sh_es_text2",
  sh_es_btn: "sh_es_btn",
  sh_es_cs_btn: "sh_es_cs_btn",
};

// Reset link sent screen constant 
export const resetLink = {
  sh_rl_logo: "sh_rl_logo",
  sh_rl_text1: "sh_rl_text1",
  sh_rl_text2: "sh_rl_text2",
  sh_rl_btn: "sh_rl_btn",
  sh_rl_cs_btn: "sh_rl_cs_btn",
};

// Reset link sent screen constant 
export const resetPassword = {
  sh_rp_logo: "sh_rp_logo",
  sh_rp_text1: "sh_rp_text1",
  sh_rp_text2: "sh_rp_text2",
  sh_rp_pass : "sh_rp_pass",
  sh_rp_c_pass : "sh_rp_c_pass",
  sh_rp_btn: "sh_rp_btn",
  sh_rp_cs_btn: "sh_rp_cs_btn",
};


// Patient Dashboard constant
export const patientDashboard = {
  sh_pd_schedule_session : "sh_pd_schedule_session",
  sh_pd_your_notes:"sh_pd_your_notes",
  sh_pd_faq:"sh_pd_faq",
  sh_pd_learn_about_wellbeing:"sh_pd_learn_about_wellbeing",
  sh_pd_join_btn : "sh_pd_join_btn",
  sh_pd_edit_btn : "sh_pd_edit_btn",
  sh_pd_cancel_btn : "sh_pd_cancel_btn",
  sh_pd_patient_name: "sh_pd_patient_name",
  sh_pd_detail_btn: "sh_pd_detail_btn"
}

// Counsellor Dashboard constant
export const counsellorDashboard = {
  sh_cd_schedule_session : "sh_cd_schedule_session",
  sh_cd_your_notes:"sh_cd_your_notes",
  sh_cd_faq:"sh_cd_faq",
  sh_cd_learn_about_wellbeing:"sh_cd_learn_about_wellbeing",
  sh_cd_join_btn : "sh_cd_join_btn",
  sh_cd_edit_btn : "sh_cd_edit_btn",
  sh_cd_cancel_btn : "sh_cd_cancel_btn",
  sh_cd_detail_btn : "sh_cd_detail_btn",
  sh_cd_counsellor_name: "sh_cd_counsellor_name"
}

// Counsellor Dashboard constant
export const noteMasterView = {
  sh_nmv_view_btn : "sh_nv_view_btn",
  sh_nmv_delete_btn:"sh_nv_cancel_btn",
}

// Counsellor Dashboard constant
export const noteInsideView = {
  sh_niv_edit_btn : "sh_nv_edit_btn",
  sh_niv_save_btn : "sh_nv_save_btn",
  sh_niv_back_btn : "sh_nv_back_btn",
  sh_niv_note_text:"sh_nv_note_text",
}

// header constant
export const headerMenu = {
  sh_pt_profile : "sh_pt_profile",
  sh_cl_profile : "sh_cl_profile",
  sh_pt_mycounsellor: "sh_pt_mycounsellor",
  sh_cl_mypatient: "sh_cl_mypatient",
  sh_pt_chng_password: "sh_pt_chng_password",
  sh_cl_chng_password: "sh_cl_chng_password",
  sh_pt_logout : "sh_pt_logout",
  sh_cl_logout : "sh_cl_logout",
  sh_pt_familyMember : 'sh_pt_addFamilyMember',
  sh_cl_familyMember : 'sh_cl_addFamilyMember'



}

export const patientDashConst = {
  sh_pt_app_name: "sh_pt_app_name",
  sh_pt_app_time: "sh_pt_app_time"
}

export const editApptTime = {
  sh_cl_Edit_date: "sh_cl_Edit_date",
  sh_cl_edit_submit: "sh_cl_edit_submit",
  sh_cl_edit_cancel: "sh_cl_edit_cancel"
}

export const requestAppt ={
  sh_pt_confirm_bt:'sh_pt_request_submit',
  sh_pt_cancel_bt:'sh_pt_request_cancel'
}

export const createApptConst = {
  sh_cl_app_day: "sh_cl_app_day",
  sh_cl_app_month: "sh_cl_app_month",
  sh_cl_app_year: "sh_cl_app_year"
}

export const viewSlotConst = {
  sh_cl_viewslot_name: "sh_cl_viewslot_name",
  sh_cl_viewslot_time: "sh_cl_viewslot_timevu",
  sh_cl_viewslot_msg: "sh_cl_viewslot_msg"
}

export const regstrSlotConst = {
  sh_lg_registerslot_date: "sh_lg_registerslot_date",
  sh_lg_registerslot_time: "sh_lg_registerslot_time"
}

export const counsellorDahsCont = {
  sh_cl_app_name: "sh_cl_app_name",
  sh_cl_app_time: "sh_cl_app_time"
}

export const cnslrHistoryConst = {
  sh_pt_session_histroy: "sh_pt_session_histroy",
  sh_pt_cancel_relation: "sh_pt_cancel_relation",
  sh_pt_histroy_close: "sh_pt_histroy_close",
  sh_pt_delete_relation: "sh_pt_delete_relation",
  sh_pt_cncl_relation: "sh_pt_cncl_relation",
  sh_pt_successful_dltrelation: "sh_pt_successful_dltrelation"
}


// WEBPACK FOOTER //
// ./src/helpers/ConstantID.js